import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

const MD = {
  p: (p) => <p className="font-body text-lg text-ink/90 leading-relaxed mb-6" {...p} />,
  h2: (p) => <h2 className="font-heading text-3xl mt-12 mb-4" {...p} />,
  h3: (p) => <h3 className="font-heading text-2xl mt-10 mb-3" {...p} />,
  strong: (p) => <strong className="font-semibold text-ink" {...p} />,
  em: (p) => <em className="italic" {...p} />,
  blockquote: (p) => <blockquote className="border-l-2 border-ink pl-6 my-8 font-editorial text-2xl text-darkgrey leading-relaxed" {...p} />,
  ul: (p) => <ul className="list-disc pl-6 space-y-2 mb-6 font-body text-lg text-ink/90" {...p} />,
  ol: (p) => <ol className="list-decimal pl-6 space-y-2 mb-6 font-body text-lg text-ink/90" {...p} />,
  a: (p) => <a className="link-underline text-ink" target="_blank" rel="noreferrer" {...p} />,
};

export const Markdown = ({ children }) => (
  <ReactMarkdown remarkPlugins={[remarkGfm]} components={MD}>{children || ""}</ReactMarkdown>
);
